/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
// MRT
import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";
//import translation function for language translation
import { useTranslation } from "react-i18next";
//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData, postData } from "utils/Gateway";
//import context
import { GlobalProvider } from "context/GlobalContext";
import { currencySymbol } from "Config/Config";

const CostTemplateListArea = ({
  downloadExcel,
  setRecords,
  search,
  checkedRecordCount,
}) => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");
  const {
    screenHeight,
    setEditCostData,
    reloadCostList,
    setReloadCostList,
    searchCostDate,
    searchCostEducators,
    searchCostClients,
  } = useContext(GlobalProvider);
  const [costList, setCostList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return costList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : costList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "cost.xlsx");
  };

  //function for get all cost
  const getAllCost = async (currentSearch = search) => {
    setLoading(true);
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_COST + `?token=${token}`;
      if (searchCostDate.length > 0) {
        requestUrl = requestUrl + `&costdate=${searchCostDate}`;
      }
      if (searchCostEducators.length > 0) {
        requestUrl = requestUrl + `&costeducators=${searchCostEducators}`;
      }
      if (searchCostClients.length > 0) {
        requestUrl = requestUrl + `&costclients=${searchCostClients}`;
      }
      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }
      console.log("request url of cost =====>", requestUrl);
      const response = await getData(requestUrl);
      console.log("response in cost =======>", response);
      if (response.status) {
        setCostList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  /* educator name html */
  const educatorBlock = ({ dataItem }) => {
    return (
      <div className="d-flex align-items-center gap-2">
        <span>{dataItem.educatorname}</span>
        <Link
          to="#viewUpdateCostPopup"
          data-bs-toggle="offcanvas"
          className="ml-auto edit_icon"
        >
          <span
            className="d-block material-symbols-outlined icon-md"
            onClick={() => {
              setEditCostData(dataItem);
            }}
          >
            edit
          </span>
        </Link>
      </div>
    );
  };

  const costPerHourCell = ({ dataItem }) => {
    return (
      <div>
        <p>
          {dataItem.costperhour} {currencySymbol}
        </p>
      </div>
    );
  };

  const costPerDateCell = ({ dataItem }) => {
    return (
      <div>
        <p>
          {dataItem.totalcost?.totalcost || 0} {currencySymbol}
        </p>
      </div>
    );
  };

  const reserveCostCell = ({ dataItem }) => {
    return (
      <div>
        <p>
          {dataItem.educatorcost || 0} {currencySymbol}
        </p>
      </div>
    );
  };

  const tableColumns = useMemo(() => withStrictFilter([
    {
      id: "educatorname",
      accessorKey: "educatorname",
      header: t("Educator"),
      Cell: ({ row }) => educatorBlock({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "activitycostdate",
      accessorKey: "activitycostdate",
      header: t("Date"),
      size: 200,
    },
    {
      id: "customreserveid",
      accessorKey: "customreserveid",
      header: t("Reservation"),
      size: 200,
    },
    {
      id: "activityname",
      accessorKey: "activityname",
      header: t("Activity"),
      size: 400,
    },
    {
      id: "clientname",
      accessorKey: "clientname",
      header: t("Client"),
      size: 200,
    },
    {
      id: "costlocation",
      accessorKey: "costlocation",
      header: t("Location"),
      size: 200,
    },
    {
      id: "locationzipcode",
      accessorKey: "locationzipcode",
      header: t("Zipcode"),
      size: 200,
    },
    {
      id: "startzipcode",
      accessorKey: "startzipcode",
      header: t("Educator Zipcode"),
      size: 200,
    },
    {
      id: "journeydistance",
      accessorKey: "journeydistance",
      header: t("Distance"),
      size: 200,
    },
    {
      id: "starttime",
      accessorKey: "starttime",
      header: t("Start"),
      size: 200,
    },
    {
      id: "endtime",
      accessorKey: "endtime",
      header: t("End"),
      size: 200,
    },
    {
      id: "minutes",
      accessorKey: "minutes",
      header: t("Activity time"),
      size: 200,
    },
    {
      id: "arrivaltime",
      accessorKey: "arrivaltime",
      header: t("Arrival time"),
      size: 200,
    },
    {
      id: "officearrivaltime",
      accessorKey: "officearrivaltime",
      header: t("Off. Arrival time"),
      size: 200,
    },
    {
      id: "returntime",
      accessorKey: "returntime",
      header: t("Return time"),
      size: 200,
    },
    {
      id: "officereturntime",
      accessorKey: "officereturntime",
      header: t("Off. Return time"),
      size: 200,
    },
    {
      id: "preparationtime",
      accessorKey: "preparationtime",
      header: t("Preparation time"),
      size: 200,
    },
    {
      id: "mountingtime",
      accessorKey: "mountingtime",
      header: t("Mounting time"),
      size: 200,
    },
    {
      id: "dismantletime",
      accessorKey: "dismantletime",
      header: t("Dismantle time"),
      size: 200,
    },
    {
      id: "gaptime",
      accessorKey: "gaptime",
      header: t("Gap time"),
      size: 200,
    },
    {
      id: "additionaltime",
      accessorKey: "additionaltime",
      header: t("Concept time"),
      size: 200,
    },
    {
      id: "totaltime",
      accessorKey: "totaltime",
      header: t("Total time") + " (Min)",
      size: 200,
    },
    {
      id: "totalcost.totaltime",
      accessorFn: (row) => row.totalcost?.totaltime ?? "",
      header: t("Time by date") + " (Min)",
      size: 200,
    },
    {
      id: "totalhours",
      accessorKey: "totalhours",
      header: t("Time by date") + " (Hrs)",
      size: 200,
    },
    {
      id: "costperhour",
      accessorKey: "costperhour",
      header: t("Cost per hour"),
      Cell: ({ row }) => costPerHourCell({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "educatorcost",
      accessorKey: "educatorcost",
      header: t("Reserve Cost"),
      Cell: ({ row }) => reserveCostCell({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "totalcost.totalcost",
      accessorFn: (row) => row.totalcost?.totalcost ?? "",
      header: t("Cost by date"),
      Cell: ({ row }) => costPerDateCell({ dataItem: row.original }),
      size: 200,
    },
  ]), [costList]);

  useEffect(() => {
    if (
      searchCostDate.length > 0 ||
      searchCostEducators.length > 0 ||
      searchCostClients.length > 0
    ) {
      getAllCost();
    }
  }, [searchCostDate, searchCostEducators, searchCostClients]);

  useEffect(() => {
    if (reloadCostList) {
      getAllCost();
      setReloadCostList(false);
    }
  }, [reloadCostList]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllCost();
    }
  }, [responseReceived]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* global search */
  useEffect(() => {
    getAllCost(search);
  }, [search]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, costList]);

  return (
    <div className="table-responsive">
      <MaterialReactTable
        {...defaultTableConfig}
        enableGlobalFilter
        globalFilterFn="strictContains"
        columns={tableColumns}
        data={costList}
        enableSorting
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        getRowId={(row) => row._id}
        state={{ rowSelection, isLoading: loading }}
        renderLoadingOverlay={() => null}
        muiLinearProgressProps={{ sx: { display: 'none' } }}
        muiCircularProgressProps={{ sx: { display: 'none' } }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
      />
    </div>
  );
};
export default CostTemplateListArea;
